<div class="pb-5 px-md-5 mt-md-5">
  <h2 class="text-info mb-4 text-wrap-pretty">Les entreprises engagées avec Opale ont mis en place des aides pour vous aider à faire face à cette situation dont vous n'êtes pas responsable :</h2>
  <div class="row g-4">
    <div class="col-12 col-lg-6" *ngFor="let customer of customers">
      <div class="card-customer">
        <div class="card-customer-header">
          <div class="card-customer-logo">
            <img [src]="customer.image | companyImage" [alt]="customer.name" *ngIf="customer.image">
            <span class="material-icons" *ngIf="!customer.image">business</span>
          </div>
          <div class="card-customer-heading">
            <h3 class="card-customer-name">{{customer.name}}</h3>
            <a class="card-customer-website" *ngIf="customer.website" [href]="customer.website" target="_blank">
              <span class="material-icons">language</span>
              <span>{{customer.website}}</span>
            </a>
          </div>
        </div>

        <p class="card-customer-description" *ngIf="customer.description">{{customer.description}}</p>

        <div class="card-customer-actions">
          <div class="card-customer-action" *ngFor="let action of customer.actions">
            <p class="card-customer-action-text" [innerHTML]="replacePlaceVariable(action.content, action.variable)"></p>
            <ul class="card-resource-info" *ngIf="action.referent || action.email || action.phone">
              <li *ngIf="action.referent">
                <span class="material-icons">person</span>
                <span>{{action.referent}}</span>
              </li>
              <li *ngIf="action.email">
                <span class="material-icons">email</span>
                <span>{{action.email}}</span>
              </li>
              <li *ngIf="action.phone">
                <span class="material-icons">phone</span>
                <span>{{action.phone}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
